module.exports = __webpack_public_path__ + "media/public/img/expedia-favicon-01-6b60a48df9950d9b9184cf83d8848d7b.svg";